const modulousIDsUk02v1 = {
    roofId: 'RFB|01|',
    parapetId: 'PAR|01|',
    facadeId: 'FCD|01|',
    balconyId: '',
    beamId: '',
    columnId: '',
    defaultWallId: 'WPA|01|',
    defaultFloorId: 'FPA|02|',
    defaultCeilingId: 'CPA|05|',
    defaultFlatInternalDoorId: 'DIS|02|UK-DIS0002',
    defaultWindowId: 'WNF|01|UK-WNF0002',
    corridorFireDoorId: 'DIS|02|UK-DIS0004',
    techSpaceSingleDoorId: 'DTS|01|UK-DTS0001',
    techSpaceDoubleDoorId: 'DTD|01|UK-DTD0001',
    coreDoorId: 'DIS|02|UK-DIS0004',
    entranceDoorId: 'DED|01|UK-DED0001'
};

export { modulousIDsUk02v1 };
//# sourceMappingURL=modulous-ids-uk02-v1.js.map
